// extracted by mini-css-extract-plugin
module.exports = {"root":"TermsOfService_root__3py7X","lastUpdated":"TermsOfService_lastUpdated__2BLcB"};